import moment from 'moment';
import { PatientFormValues } from '../components/Forms/Patient';
import { PatientItem } from '../components/Tables/Patients';
import { isCodeableConceptEqual } from '../modules/unsw-fhir/CodeableConcept';
import { IPatient } from '../modules/unsw-fhir/Patient';
function randomIntFromInterval(min: number, max: number) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}
export const getDob = (patient: IPatient): string => {
  return patient.birthDate || 'Unknown';
};

export const getBirthDate = (patient: IPatient | undefined): string => {
  return patient && patient.birthDate
    ? moment(patient.birthDate).format('DD-MM-YYYY')
    : 'Unknown';
};

export const getGender = (patient: IPatient | undefined): string => {
  if (!patient) return 'Unknown';
  return patient.gender || 'unknown';
};

export const isActive = (patient: IPatient | undefined): boolean => {
  if (!patient) return false;
  return !!patient.active;
};

export const getMrn = (patient: IPatient | undefined): string => {
  if (!patient) return 'Unknown';
  const { identifier: identifiers = [] } = patient;
  const identifier = identifiers.find(identifier =>
    isCodeableConceptEqual(identifier.type, {
      coding: [
        { system: 'http://terminology.hl7.org/CodeSystem/v2/0203', code: 'MR' },
      ],
    }),
  );
  return identifier && identifier.value ? identifier.value : 'Unknown';
};

export const getFirstName = (patient: IPatient | undefined): string => {
  if (!patient || !patient.name || patient.name.length <= 0) return 'Unknown';
  const name = patient.name.find(p => p.use === 'official') || patient.name[0];
  return name.given && name.given[0] ? name.given[0] : 'Unknown';
};

export const getLastName = (patient: IPatient | undefined): string => {
  if (!patient || !patient.name || patient.name.length <= 0) return 'Unknown';
  const name = patient.name.find(p => p.use === 'official') || patient.name[0];
  return name.family || 'Unknown';
};

export const getDisplayName = (patient: IPatient | undefined): string => {
  if (!patient || !patient.name || patient.name.length <= 0) return 'Unknown';
  const name = patient.name.find(p => p.use === 'official') || patient.name[0];
  return name.text || `${getFirstName(patient)} ${getLastName(patient)}`;
};

export const getPatentItem = (patient: IPatient): PatientItem => {
  const firstName = getFirstName(patient);
  const lastName = getLastName(patient);
  const dob = getDob(patient);
  const mrn = getMrn(patient);
  const gender = getGender(patient);
  const id = patient.id || '';
  return {
    firstName,
    lastName,
    dob,
    mrn,
    gender,
    id,
    progress: (Math.random() * 100).toString(),
    score: randomIntFromInterval(0, 19).toString(),
  };
};

export const getPatientFomValues = (patient: IPatient): PatientFormValues => {
  const { firstName, lastName, dob, mrn, gender } = getPatentItem(patient);

  return {
    firstName,
    lastName,
    gender: { value: gender, label: gender },
    dateOfBirth: dob,
    mrn,
  };
};
